"use strict";

function buildRequestUrl(format, interval, epoch, sep, order, time, streams) {
    var request_url = METOBS_API_URL+'/api/data.'+format+'?';
    request_url += 'interval='+interval;
    request_url += '&epoch='+epoch;
    request_url +='&sep='+sep || ',';
    request_url += '&order='+order;
    request_url+=time;
    request_url+='&symbols='+streams;
    return request_url;
}

module.exports.buildRequestUrl = buildRequestUrl;
